import { render, staticRenderFns } from "./DecastAnimatedLogo.vue?vue&type=template&id=2dd1bef0&scoped=true&"
import script from "./DecastAnimatedLogo.vue?vue&type=script&lang=js&"
export * from "./DecastAnimatedLogo.vue?vue&type=script&lang=js&"
import style0 from "./DecastAnimatedLogo.vue?vue&type=style&index=0&id=2dd1bef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd1bef0",
  null
  
)

export default component.exports